/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { Grid, Typography, IconButton, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { AddBox } from '@material-ui/icons';

import { useDispatch } from 'react-redux';

const useStyles = makeStyles(theme => ({
    listComponent: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
    },
    inputRoot: {
        '& .MuiInputBase-input': {
            height: '8px'
        }
    },
    chipArray: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: theme.spacing(0.5),
      margin: 0,
      maxHeight: 200,
      overflowY: 'auto',
      alignContent: 'flex-start'
    },
    chip: {
      margin: theme.spacing(0.5),
      maxWidth: 150,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    radioLabel: {
      marginLeft: '0.7rem'
    }
}));

const ListTags = props => {
    const { 
        tags,
        modifyTags,
        allTags,
        action,
        isTemplateReadOnly,
        label,
        userTags = true,
        protectedTags = []
    } = props;
    const [newTag, setNewTag] = React.useState('');
    const [isAddEnabled, setIsAddEnabled] = React.useState(true);
    const filter = createFilterOptions();
    const classes = useStyles();
    const dispatch = useDispatch();

    const [modifiedTags, setModifiedTags] = useState(tags);
    const handleDelete = (chipToDelete) => () => {
        let updatedTags = modifiedTags.filter(tag => {
            return tag != chipToDelete;
        });
        setModifiedTags(updatedTags);
        modifyTags(updatedTags);
    };

    useEffect(() => {
        setModifiedTags(tags);
    }, [tags])

    useEffect(() => {
        if(action && !isTemplateReadOnly && isTemplateReadOnly!==undefined) {
            dispatch(action());
        }
    }, [isTemplateReadOnly])

    return (
        <>
            {<Grid item style={{ padding: '8px 0px 0px 0px' }} className={classes.listComponent}>
                {(!isTemplateReadOnly || modifiedTags.length !== 0) ? 
                    (<Typography className={classes.radioLabel} >
                        {label ? `${label} : ` : 'Tags : '}
                    </Typography>) :
                    ''}
                {modifiedTags.length > 0 && 
                    <div className={classes.chipArray}>
                        {modifiedTags.map((tag, index) => {
                            const isProtected = protectedTags.includes(tag);
                        return (
                            <li key={index}>
                            {isTemplateReadOnly ? 
                                <Chip
                                    label={tag}
                                    className={classes.chip}
                                /> : 
                                <Chip
                                    label={tag}
                                    onDelete={isProtected ? undefined : handleDelete(tag)}
                                    className={classes.chip}
                                    title={tag}
                                />
                            }
                            </li>
                        );
                        })}
                    </div>
                }
                {(!isTemplateReadOnly && !(allTags.length === modifiedTags.length && !userTags)) &&
                    (isAddEnabled ?
                        <IconButton 
                            variant="outlined" 
                            size="small"
                            color="primary"
                            onClick={() => setIsAddEnabled(false)}
                            >
                            <AddBox
                                color={'primary'}
                                size="medium"
                                />
                        </IconButton> :
                        <Autocomplete
                            className={classes.inputRoot}
                            onChange={(event, newValue) => {
                                if (typeof newValue === 'string') {
                                    let tag = [...new Set([...modifiedTags, allTags.includes(newValue) ? newValue : newTag])];
                                    setModifiedTags(tag);
                                    modifyTags(tag);
                                }
                                setIsAddEnabled(true);
                            }}
                            filterOptions={(options, params) => {
                                const filtered = filter(options, params);        
                                if (params.inputValue !== '' && userTags) {
                                    filtered.push( `Add tag : "${params.inputValue}"`,
                                    );
                                    setNewTag(params.inputValue);
                                }        
                                return filtered;
                            }}
                            onBlur={() => setIsAddEnabled(true)}
                            openOnFocus={true}
                            size="small"
                            id="add-tags"
                            options={allTags.filter(tag => !modifiedTags.includes(tag))}
                            renderOption={option => option}
                            style={{ width: 200, marginLeft: '10px' }}
                            freeSolo={userTags}
                            renderInput={(params) => (
                                <TextField 
                                {...params}
                                autoFocus="true"
                                size="small"
                                variant="outlined" />
                            )}
                    />)
                }
            </Grid>}
        </>
    );
}
export default ListTags;